// extracted by mini-css-extract-plugin
export default {"scrollbar":"scrollbar_scrollbar__ibc9i"};